<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="rgba(255, 255, 255, 0.9)"
      color="#1A237E"
      spinner="mini-spinner"
    />

    <ServerError v-if="ServerError" />

    <v-row class="mb-4 align-center px-4">
      <v-col cols="12" class="d-flex align-center">
        <v-btn icon @click="$router.go(-1)" class="mr-2">
          <v-icon color="#1A237E">mdi-arrow-left</v-icon>
        </v-btn>
        <h2 class="page-title">Sighting Analysis</h2>
        <v-spacer></v-spacer>
        <v-chip color="#1A237E" dark class="px-4 font-weight-bold">
          ID: {{ $route.query.id.substring(0, 8) }}...
        </v-chip>
      </v-col>
    </v-row>

    <v-row class="px-4">
      <v-col cols="12" md="8">
        <v-card flat class="rounded-xl pa-6 elevation-1 fill-height d-flex align-center">
          <v-avatar color="#1A237E" size="70" class="mr-6 elevation-3">
            <v-icon dark size="36">mdi-account-circle</v-icon>
          </v-avatar>
          <div>
            <div class="text-h4 font-weight-black grey--text text--darken-4 mb-1">
              {{ user.first_name }} {{ user.last_name }}
            </div>
            <div class="d-flex align-center grey--text text--darken-1">
              <v-icon small class="mr-2">mdi-phone</v-icon>
              <span class="text-h6 font-weight-medium">{{ user.phone }}</span>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card flat class="rounded-xl pa-6 elevation-1 text-center fill-height">
          <div class="text-overline grey--text font-weight-bold">Total Verified Sightings</div>
          <div class="display-2 font-weight-black primary--text mt-2">
            {{ totalLength }}
          </div>
          <v-progress-linear
            :value="(totalLength / 50) * 100"
            color="primary"
            rounded
            height="6"
            class="mt-4"
          ></v-progress-linear>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-6 px-4">
      <v-col cols="12">
        <v-card flat class="rounded-xl elevation-2 overflow-hidden border-map">
          <div class="pa-4 white d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-map-marker-distance</v-icon>
            <span class="font-weight-bold grey--text text--darken-3">Geographic Distribution</span>
          </div>
          <div id="googlemap"></div>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-8 px-4">
      <v-col cols="12">
        <h3 class="section-title mb-4 ml-2">Sighting Logs</h3>
        <v-card flat class="rounded-xl elevation-1 overflow-hidden">
          <v-data-table
            :headers="headers"
            :items="records"
            class="modern-table"
            hide-default-footer
            @click:row="rowClicked"
          >
            <template v-slot:item.create_date="{ item }">
              <span class="font-weight-bold">{{ new Date(item.create_date).toLocaleDateString() }}</span>
              <div class="caption grey--text">{{ new Date(item.create_date).toLocaleTimeString() }}</div>
            </template>
            
            <template v-slot:item.length="{ item }">
              <v-chip small color="blue lighten-5" class="blue--text text--darken-4 font-weight-black">
                {{ item.length }} FT
              </v-chip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <div class="text-center py-10">
      <v-pagination v-model="page" :length="pagelength" circle color="#1A237E"></v-pagination>
    </div>
  </div>
</template>

<script>
import axios from "axios";

/* global google */

export default {
  data() {
    return {
      totalLength: 0,
      page: 1,
      appLoading: false,
      ServerError: false,
      user: {},
      records: [],
      gmap: null,
      pagelength: 0,
      whaleIcon: {
        url: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCIgdmlld0JveD0iMCAwIDY0IDY0Ij48cGF0aCBmaWxsPSIjMUEyMzdFIiBkPSJNNjIgMzJjMC00LTMtOC04LTEwLTYtMi0xNy0zLTI0LTMtMTUgMC0yNCA4LTI2IDEzIDAgMCA1IDMgNiA1czEtNiAzLTYgOC0xIDEwIDJjMCAwIDIgMyA0IDNzMi0tMyA0LTMzYzQgMCAxMiAxIDE4IDMgNSAyIDggNiA4IDZzMC01IDAtOXoiLz48Y2lyY2xlIGZpbGw9IndoaXRlIiBjeD0iMTYiIGN5PSIzMCIgcj0iMSIvPjxjaXJjbGUgZmlsbD0id2hpdGUiIGN4PSIyMCIgY3k9IjI4IiByPSIxIi8+PGNpcmNsZSBmaWxsPSJ3aGl0ZSIgY3g9IjI0IiBjeT0iMjkiIHI9IjEiLz48Y2lyY2xlIGZpbGw9IndoaXRlIiBjeD0iMjgiIGN5PSIyNyIgcj0iMSIvPjxjaXJjbGUgZmlsbD0id2hpdGUiIGN4PSIzMiIgY3k9IjI5IiByPSIxIi8+PGNpcmNsZSBmaWxsPSJ3aGl0ZSIgY3g9IjM2IiBjeT0iMjgiIHI9IjEiLz48L3N2Zz4=',
        scaledSize: new google.maps.Size(60, 60),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(30, 30)
      },
      headers: [
        { text: "Timestamp", value: "create_date", width: "150px" },
        { text: "Vessel Name", value: "boatname" },
        { text: "Vessel Registration", value: "boatno" },
        { text: "Location (Field)", value: "field" },
        { text: "Estimated Length", value: "length", align: "center" },
      ],
    };
  },
  watch: {
    page() { this.getData(); }
  },
  mounted() {
    this.initMap();
    this.getData();
  },
  methods: {
    initMap() {
      this.gmap = new google.maps.Map(document.getElementById("googlemap"), {
        center: { lat: 9.5260093, lng: 76.8144186 },
        zoom: 3,
        disableDefaultUI: true,
        zoomControl: true,
        styles: [

          { "featureType": "landscape", "stylers": [{ "color": "#f5f5f5" }] },
          { "elementType": "labels.text.fill", "stylers": [{ "color": "#1A237E" }] }
        ]
      });
    },
    rowClicked(item) {
      this.$router.push("/admin/uploaddetail?id=" + item._id);
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/admin/record/view",
        method: "post",
        headers: { token: localStorage.getItem("token") },
        data: { id: this.$route.query.id, page: this.page, limit: 10 }
      })
      .then((res) => {
        this.appLoading = false;
        if (res.data.status) {
          this.user = res.data.user;
          this.records = res.data.data;
          this.totalLength = res.data.totalLength;
          this.pagelength = Math.ceil(this.totalLength / 10);
          
          this.records.forEach((record) => {
            const marker = new google.maps.Marker({
              position: { lat: record.location[1], lng: record.location[0] },
              map: this.gmap,
              icon: this.whaleIcon,
              animation: google.maps.Animation.DROP,
              title: record.boatname
            });

            const info = new google.maps.InfoWindow({
              content: `
                <div style="padding:10px; font-family: 'Inter', sans-serif;">
                  <h4 style="color:#1A237E; margin:0">${record.boatname}</h4>
                  <p style="font-size:12px; margin:5px 0;">Length: <b>${record.length}ft</b></p>
                  <a href="/admin/uploaddetail?id=${record._id}" style="text-decoration:none; color:white; background:#1A237E; padding:4px 8px; border-radius:4px; font-size:10px; display:inline-block;">DETAILS</a>
                </div>`
            });

            marker.addListener("click", () => info.open(this.gmap, marker));
          });
        }
      })
      .catch((err) => {
        this.appLoading = false;
        this.ServerError = true;
        console.error(err);
      });
    }
  }
};
</script>

<style scoped>
#googlemap { height: 450px; width: 100%; }

.page-title {
  font-family: 'Syne', sans-serif;
  font-weight: 800;
  text-transform: uppercase;
  color: #1A237E;
  letter-spacing: 2px;
}

.section-title {
  font-family: 'Syne', sans-serif;
  font-weight: 700;
  color: #546E7A;
  text-transform: uppercase;
}

.border-map { border: 4px solid white; }

.modern-table >>> th {
  background-color: #F8FAFC !important;
  text-transform: uppercase;
  font-size: 0.75rem !important;
  letter-spacing: 1px;
  color: #546E7A !important;
}

.modern-table >>> tr { cursor: pointer; transition: 0.2s; }
.modern-table >>> tr:hover { background-color: #F1F4F9 !important; }
</style>